import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref,onBeforeMount,watch,computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import CrApi from "../service/CrApi";
import SecurityService from "../service/SecurityService";
import store from "../store/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimezoneListComponent',
  props: [
    'timezoneMode',
    'preserveTimezone',
    'inputWidth',
    'value'],
  emits: ['update:input','update:value'],
  setup(__props, { emit: __emit }) {

const props = __props;
const route = ref<any>(useRoute());
const router = ref<any>(useRouter());
const isLoading = ref(false);
const allTimezones = ref([]);
const el = ref(null);
const websiteToken = ref(SecurityService.getToken());
const timezoneBehavior = ref(1);
const newTimezoneOffsets = ref([
    {value:-12.0, name:'UTC -12:00', type: 'Offset'},
    {value:-11.0, name:'UTC -11:00', type: 'Offset'},
    {value:-10.0, name:'UTC -10:00', type: 'Offset'},
    {value:-9.5, name:'UTC -9:30', type: 'Offset'},
    {value:-9.0, name:'UTC -9:00', type: 'Offset'},
    {value:-8.0, name:'UTC -8:00', type: 'Offset'},
    {value:-7.0, name:'UTC -7:00', type: 'Offset'},
    {value:-6.0, name:'UTC -6:00', type: 'Offset'},
    {value:-5.0, name:'UTC -5:00', type: 'Offset'},
    {value:-4.0, name:'UTC -4:00', type: 'Offset'},
    {value:-3.5, name:'UTC -3:30', type: 'Offset'},
    {value:-3.0, name:'UTC -3:00', type: 'Offset'},
    {value:-2.0, name:'UTC -2:00', type: 'Offset'},
    {value:-1.0, name:'UTC -1:00', type: 'Offset'},
    {value:0.0, name:'UTC ±00:00', type: 'Offset'},
    {value:1.0, name:'UTC +1:00', type: 'Offset'},
    {value:2.0, name:'UTC +2:00', type: 'Offset'},
    {value:3.0, name:'UTC +3:00', type: 'Offset'},
    {value:3.5, name:'UTC +3:30', type: 'Offset'},
    {value:4.0, name:'UTC +4:00', type: 'Offset'},
    {value:4.5, name:'UTC +4:30', type: 'Offset'},
    {value:5.0, name:'UTC +5:00', type: 'Offset'},
    {value:5.5, name:'UTC +5:30', type: 'Offset'},
    {value:5.75, name:'UTC +5:45', type: 'Offset'},
    {value:6.0, name:'UTC +6:00', type: 'Offset'},
    {value:7.0, name:'UTC +7:00', type: 'Offset'},
    {value:8.0, name:'UTC +8:00', type: 'Offset'},
    {value:8.5, name:'UTC +8:30', type: 'Offset'},
    {value:8.75, name:'UTC +8:45', type: 'Offset'},
    {value:9.0, name:'UTC +9:00', type: 'Offset'},
    {value:9.5, name:'UTC +9:30', type: 'Offset'},
    {value:10.0, name:'UTC +10:00', type: 'Offset'},
    {value:10.5, name:'UTC +10:30', type: 'Offset'},
    {value:11.0, name:'UTC +11:00', type: 'Offset'},
    {value:12.0, name:'UTC +12:00', type: 'Offset'},
    {value:12.75, name:'UTC +12:45', type: 'Offset'},
    {value:13.0, name:'UTC +13:00', type: 'Offset'},
    {value:14.0, name:'UTC +14:00', type: 'Offset'}
]);
const timezoneOffset = ref([
    {value:-12.0, name:'(GMT -12:00) International Date Line West', type: 'Offset'},
    {value:-11.0, name:'(GMT -11:00) Midway Island, Samoa', type: 'Offset'},
    {value:-10.0, name:'(GMT -10:00) Hawaii', type: 'Offset'},
    {value:-9.0, name:'(GMT -9:00) Alaska', type: 'Offset'},
    {value:-8.0, name:'(GMT -8:00) Pacific Time (US & Canada)', type: 'Offset'},
    {value:-7.0, name:'(GMT -7:00) Mountain Time (US & Canada)', type: 'Offset'},
    {value:-6.0, name:'(GMT -6:00) Central Time (US & Canada), Mexico City', type: 'Offset'},
    {value:-5.0, name:'(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima', type: 'Offset'},
    {value:-4.0, name:'(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz', type: 'Offset'},
    {value:-3.5, name:'(GMT -3:30) Newfoundland', type: 'Offset'},
    {value:-3.0, name:'(GMT -3:00) Brazil, Buenos Aires, Georgetown', type: 'Offset'},
    {value:-2.0, name:'(GMT -2:00) Mid-Atlantic', type: 'Offset'},
    {value:-1.0, name:'(GMT -1:00) Azores, Cape Verde Islands', type: 'Offset'},
    {value:0.0, name:'(GMT) Western Europe Time, London, Lisbon, Casablanca', type: 'Offset'},
    {value:1.0, name:'(GMT +1:00) Brussels, Copenhagen, Madrid, Paris', type: 'Offset'},
    {value:2.0, name:'(GMT +2:00) Kaliningrad, South Africa', type: 'Offset'},
    {value:3.0, name:'(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg', type: 'Offset'},
    {value:3.5, name:'(GMT +3:30) Tehran', type: 'Offset'},
    {value:4.0, name:'(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi', type: 'Offset'},
    {value:4.5, name:'(GMT +4:30) Kabul', type: 'Offset'},
    {value:5.0, name:'(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent', type: 'Offset'},
    {value:5.5, name:'(GMT +5:30) Bombay, Calcutta, Madras, New Delhi', type: 'Offset'},
    {value:5.75, name:'(GMT +5:45) Kathmandu', type: 'Offset'},
    {value:6.0, name:'(GMT +6:00) Almaty, Dhaka, Colombo', type: 'Offset'},
    {value:7.0, name:'(GMT +7:00) Bangkok, Hanoi, Jakarta', type: 'Offset'},
    {value:8.0, name:'(GMT +8:00) Beijing, Perth, Singapore, Hong Kong', type: 'Offset'},
    {value:9.0, name:'(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk', type: 'Offset'},
    {value:9.5, name:'(GMT +9:30) Adelaide, Darwin', type: 'Offset'},
    {value:10.0, name:'(GMT +10:00) Eastern Australia, Guam, Vladivostok', type: 'Offset'},
    {value:11.0, name:'(GMT +11:00) Magadan, Solomon Islands, New Caledonia', type: 'Offset'},
    {value:12.0, name:'(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka', type: 'Offset'}
]);
const timezones = ref(null);
const emit = __emit;
const propsRefValue = ref<any>(props.value);
const propsRefTimeZoneMode = ref<any>(props.timezoneMode);
const valueResult = ref(props.value);

onBeforeMount(async () => {
    await load();
})

let selectedTimezone = computed({
    get() {
        if (!isNaN(parseFloat(props.value))) {
            propsRefValue.value = parseFloat(props.value)
        }
        const val = allTimezones.value.find(obj => {
            return obj.value === props.value;
        })
        const valueResponse = (val === undefined) ? {} : val;
        valueResult.value = valueResponse;
        return valueResponse;
    },
    set(val) {
        if (val === undefined || val === null) {
            return;
        }
        let newValue;
        if (Object.keys(val).length !== 0 && val.value !== undefined) {
            newValue = val.value;
        }
        if (!isNaN(parseFloat(newValue))) {
            newValue = parseFloat(newValue);
        }

        if (props.preserveTimezone === true && timezoneBehavior.value !== 2) {
            window.localStorage.setItem('cr-selected-timezone', newValue);
        }
        emit('update:input',newValue);
    }
});

const allTimezoneNames = computed(() => {
    return allTimezones.value;
})

watch(() => propsRefTimeZoneMode , () => {
    if (typeof props.timezoneMode === 'undefined') {
        propsRefTimeZoneMode.value = 'default';
    }
    let value;
    if (Object.keys(selectedTimezone.value).length !== 0 && selectedTimezone.value !== undefined) {
        value = selectedTimezone.value;
    }

    if (value === '' && value !== 0) {
        if (timezoneBehavior.value !== 2) {
            selectedTimezone.value = ['default', 'timezone'].indexOf(props.timezoneMode) > -1 ? { value: 'America/New_York' } : {value: 'account'};
        } else {
            selectedTimezone.value = route.value.name === 'account.setting' ? {value: ''} : {value: 'account'};
        }
    }})

watch(() => valueResult.value, () => {
    let value;

    if (valueResult.value && Object.keys(valueResult.value).length !== 0 && valueResult.value !== undefined) {
        value = valueResult.value;
    }
    if (!isNaN(parseFloat(value))) {
        value = parseFloat(value);
    }

    if (props.preserveTimezone === true && timezoneBehavior.value  !== 2) {
        window.localStorage.setItem('cr-selected-timezone', value);
    }
    emit('update:value',valueResult.value);
})

async function load() {
  if(Boolean(parseFloat(props.value))) {
    valueResult.value = parseFloat(props.value);
  }
    timezoneBehavior.value = store.getters.getTimezoneBehavior;
    if (timezoneBehavior.value === 2) {
        timezoneOffset.value = newTimezoneOffsets.value;
    }
    if (props.timezoneMode !== undefined) {
        if (props.timezoneMode === 'offset') {
            allTimezones.value = timezoneOffset.value;

        } else if (props.timezoneMode === 'timezone' || props.timezoneMode === 'default') {
            const params = { website_token: websiteToken.value };
            let response = await CrApi.requestV2('system/timezone/',params);
            timezones.value = response.timezone;
            if (props.timezoneMode === 'default') {
                allTimezones.value = timezones.value.concat(timezoneOffset.value);
            } else if (props.timezoneMode === 'timezone') {
                allTimezones.value = timezones.value;
            }

            const states = ['account.setting'];
            if (timezoneBehavior.value === 2 && states.indexOf(route.value.name) === -1) {
                allTimezones.value.unshift({value:'account', name:'Account\'s Timezone', offset: 'account'});
            }

            if (route.value.name === 'account.setting') {
                allTimezones.value.unshift({value:'', name:'Default (America/New York)', offset: 'default'});
            }
        }
    }

    if (props.preserveTimezone === true && timezoneBehavior.value !== 2) {
        if (window.localStorage.getItem('cr-selected-timezone') !== null) {
            const value = window.localStorage.getItem('cr-selected-timezone');
            selectedTimezone.value = {value:value }
          valueResult.value = {value: value};
        }
    }

}

function selectDefaultTz() {
  if (allTimezoneNames.value.length > 0) {
    valueResult.value = allTimezoneNames.value[0].value;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_autocomplete, {
      "hide-details": "",
      density: "compact",
      variant: "outlined",
      modelValue: valueResult.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueResult).value = $event)),
      items: allTimezoneNames.value,
      "item-title": "name",
      "item-value": "value",
      search: 'string',
      clearable: "",
      "clear-icon": "mdi-close-circle",
      "onClick:clear": selectDefaultTz
    }, null, 8 /* PROPS */, ["modelValue", "items"])
  ]))
}
}

})